import React from 'react';

import CrmZone from '@swf/components/CrmZone/CrmZone';
import Translation from '@swf/components/Translation/Translation';
import { CRMZone } from '@swf/core/enums';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTWCL_Get_your_new_player_bonus,
  TXTWCL_YouXre_in
} from './RMFItBonusOffer.messages.json';

const RMFITBonusOffer: React.FunctionComponent = () => (
  <Container
    page={RMFITBonusOffer}
    headerProps={{
      buttons: { back: false },
      title: <Translation {...TXTWCL_YouXre_in} />
    }}
    pageTopTitle={<Translation {...TXTWCL_Get_your_new_player_bonus} />}
  >
    <CrmZone zoneId={CRMZone.SWC_TRANSITION_TO_WC2} componentType="Single" dynamicHeight />
    <CTAButton />
  </Container>
);

RMFITBonusOffer.displayName = 'RMFItBonusOffer';

export default RMFITBonusOffer;
